import { Modal, Table, Badge } from "react-bootstrap";
import { format } from "date-fns";
import currency from "currency.js";
import { useState } from "react";
import { useCurrencies } from "../../../utils/hooks";

const settlementBadgeVariant = (handleSettlementBy) => {
  switch (handleSettlementBy) {
    case "incentive":
      return "info";
    case "vendor":
      return "secondary";
    default:
      return "dark";
  }
};

export default function PromoIncentivePayoutLogModal({ show, onHide, payout }) {
  const logs = payout?.promo_incentive_payout_log || [];
  const incentiveName = payout?.promo_incentive?.Name;
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const { prevailingCurrencySymbol } = useCurrencies();

  const money = (value) =>
    currency(value || 0, {
      symbol: prevailingCurrencySymbol,
      precision: 2,
    }).format();
  const totalClaimed = logs.reduce(
    (sum, log) => sum + (log.claimAmount || 0),
    0,
  );
  const totalAmount = logs.reduce((sum, log) => sum + (log.amount || 0), 0);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      scrollable
      animation={false}
      autoFocus={false}
      enforceFocus={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>
          Promo Incentive Claimed Log
          {incentiveName ? ` - ${incentiveName}` : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="table-responsive">
          <Table striped className="align-middle mb-0">
            <thead>
              <tr>
                {/* <th>Invoice No</th> */}
                <th>Bar Code</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Claim Amount</th>
                <th>Valuation / Claim</th>
                <th>Amount</th>
                {/* <th>Settled By</th>
                <th>Account</th>
                <th>Settle All</th>
                <th>Idempotency Key</th> */}
                <th>Settled By</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {logs.length ? (
                logs.map((log) => (
                  <tr key={log.id}>
                    {/* <td>{log.invoiceNo || "—"}</td> */}
                    <td>{log?.itemBarCode ?? "_"}</td>
                    <td>{log?.itemName ?? "_"}</td>
                    <td>{log?.quantity ?? "—"}</td>
                    <td>{log?.claimAmount ?? "—"}</td>
                    <td>{money(log.valuationPerClaim)}</td>
                    <td>{money(log.amount)}</td>
                    <td>
                      {log?.handleSettlementBy === "incentive"
                        ? `${log?.handleSettlementBy} Account`
                        : log?.handleSettlementBy ?? "_"}
                    </td>
                    {/* <td>
                      <Badge
                        bg={settlementBadgeVariant(log.handleSettlementBy)}
                      >
                        {log.handleSettlementBy || "—"}
                      </Badge>
                    </td> */}
                    {/* <td>{log.AccountID || "—"}</td> */}
                    {/* <td>
                      <Badge bg={log.SettleAll ? "success" : "secondary"}>
                        {log.SettleAll ? "Yes" : "No"}
                      </Badge>
                    </td> */}
                    {/* <td>
                      <small className="text-muted">
                        {log.idempotencyKey || "—"}
                      </small>
                    </td> */}
                    <td>
                      {log.createdAt
                        ? format(
                            new Date(log.createdAt),
                            "MMM dd, yyyy HH:mm:a",
                          )
                        : "—"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4">
                    No logs recorded for this claim.
                  </td>
                </tr>
              )}
            </tbody>
            {/* {logs.length > 0 && (
              <tfoot>
                <tr className="fw-bold">
                  <td>Total</td>
                  <td>{totalClaimed}</td>

                  <td>{money(totalAmount)}</td>
                  <td colSpan={5} />
                </tr>
              </tfoot>
            )} */}
          </Table>

          <div
            className={
              btnSummryActive
                ? `summaryNew border-top open`
                : `summaryNew border-top`
            }
          >
            {/*  For Current Period  */}
            <div className="mb-3 row mt-3">
              <div className="gridCont d-flex gap-3">
                <div
                  className="gridChild gridChildBorderLeftBlue "
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(payout?.claimedAmount ?? 0, {
                        symbol: "",
                      }).format()}
                    </p>
                    <p className="gridChld2">Total Claimed</p>
                  </div>

                  {/* <div className="gridChildRight">
                              <SummaryChartIconUp />
                              <p>5%</p>
                            </div> */}
                </div>

                <div
                  className="gridChild gridChildBorderLeftOrange 
          "
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(payout?.remainingClaim ?? 0, {
                        symbol: "",
                      }).format()}
                    </p>
                    <p className="gridChld2">Total Claims Remaining</p>
                  </div>

                  {/* <div className="gridChildRight">
                              <SummaryChartIconUp />
                              <p>5%</p>
                            </div> */}
                </div>

                <div
                  className="gridChild gridChildBorderLeftBrown "
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(totalAmount ?? 0, {
                        symbol: prevailingCurrencySymbol,
                      }).format()}
                    </p>
                    <p className="gridChld2">Total Monetary Valuation</p>
                  </div>

                  {/* <div className="gridChildRight">
                              <SummaryChartIconDown />
                              <p>5%</p>
                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
